import React from 'react'
import { Button } from './button'
export default function Nav() {
  const handleSkills = () =>{
    const projectsElement = document.getElementById('skill');
    projectsElement.scrollIntoView({ behavior: 'smooth' });
  }
  const handlePro = () =>{
    const projectsElement = document.getElementById('project');
    projectsElement.scrollIntoView({ behavior: 'smooth' });
  }
  const handleSoc = () =>{
    const projectsElement = document.getElementById('contact');
    projectsElement.scrollIntoView({ behavior: 'smooth' });
  }
  return (
    <div className=' w-screen border-b border-muted bg-background flex flex-row justify-between items-center px-10 h-[70px]'>
      <h1 className='text-2xl text-semibold'>Soyong.</h1>


<ul className='flex flex-row gap-3 lg:gap-5 text-xs lg:text-sm md:tetx-sm justify-center items-center'>
<li className='hover:underline underline-offset-1' onClick={handleSkills}>Skills</li>
<li className='hover:underline underline-offset-1' onClick={handlePro}>Projects</li>
<li className='hover:underline underline-offset-1' onClick={handleSoc}>Social</li>
</ul>
    </div>
  )
}
